import { ReviewOrderBy } from '@notino/shared/definitions/types';

import { IOrderBy } from '@containers/ProductDetailContainer/model';

export const orderByOptions: IOrderBy[] = [
  { key: ReviewOrderBy.DateTime, desc: true },
  { key: ReviewOrderBy.DateTime, desc: false },
  { key: ReviewOrderBy.Rating, desc: true },
  { key: ReviewOrderBy.Rating, desc: false },
  { key: ReviewOrderBy.Favorite, desc: true },
];
